import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './header.scss';
import { constants } from '../../constants';

const { BASE_IMAGE_URL } = constants;

const Header = () => {
    const groupLogo = sessionStorage.getItem('groupLogo');

    return (
        <Container fluid className="header d-flex">
            <Row className="header-md align-self-center">
                <Col className="header-logo dsmNone">
                    <div className="group-logo">
                        <img src={groupLogo || ''} />
                    </div>
                    <div className="powered-by">
                        <img src={BASE_IMAGE_URL + 'poweredBy.svg'} alt="powered by" />
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default Header;
